// import React, { useCallback, useEffect, useState } from "react";
// import EventFilterComponent from "containers/Events/EventFilter/EventFilter";
import BookingInfoCard from "containers/Company/EventBookingInfo/InfoCard/EventBookingContainer";
import TitleUnderlined from "components/TitleUnderlined/TitleUnderlined";
import { Row, Col, Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import useViewport from "components/UseViewport/UseViewport";

const EventBookingInfo = () => {
  const { width } = useViewport();
  const breakpoint = 900;

  return (
    <>
      <div
        style={{
          margin: "5%",
        }}
      >
        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            paddingLeft: "0.5em",
          }}
        >
        </div> */}
        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
          }}
        >
          <Col span={width < breakpoint ? 24 : 16}>
            <TitleUnderlined title="Booking av arrangement" />
          </Col>
          <Col
            span={width < breakpoint ? 24 : 8}
            style={
              width < breakpoint ? { textAlign: "left", marginTop: "2em", marginBottom: "2em" } : { textAlign: "right" }
            }
          >
            <Button
              href="/company/event-booking/"
              size="large"
              icon={<ArrowRightOutlined />}
              style={{ backgroundColor: "var(--secondary-color)", color: "var(--light)" }}
            >
              Gå til booking
            </Button>
          </Col>
        </Row>
        <div
          style={{
            padding: ".4em",
            marginTop: "1em",
          }}
        >
          Booking for bedriftspresentasjoner høsten 2021 åpner tirsdag 23. mars klokken 12:00.
          <br />
          Dersom du har spørsmål, eller din bedrift ønsker påminnelse per mail eller telefon, ta kontakt på{" "}
          <a href="mailto:bedrift@bindeleddet.no">bedrift@bindeleddet.no</a>.
        </div>
        <BookingInfoCard />
      </div>
    </>
  );
};

export default EventBookingInfo;
